export * from './prizm-icons-svg.module';
export * from './prizm-icons-svg.registry';
export * from './prizm-icons-svg.component';
export * from './svg/my-icons';
